import { useThreadRegistry } from 'src/hooks';
import { ConversationRole } from 'src/types';
import { AvatarImage } from 'src/components/AvatarImage';
import { UserImage } from 'src/v2/components/UserImage';
import { SpinnerSimple } from 'src/v2/commonComponents/SpinnerSimple';
import { SVG_SIZE_XL } from 'src/constants';
import styles from './MessageAuthorPicture.module.scss';

interface MessageAuthorPictureProps {
  role: ConversationRole;
  canShowProgress?: boolean;
}

export const MessageAuthorPicture = ({
  role,
  canShowProgress,
}: MessageAuthorPictureProps) => {
  const { isSubmitHappened } = useThreadRegistry();

  const isUser = role === ConversationRole.USER;

  return (
    <div className={styles.root}>
      {isUser ? (
        <div className={styles.icon}>
          <UserImage size={SVG_SIZE_XL} />
        </div>
      ) : (
        <AvatarImage size={SVG_SIZE_XL} />
      )}

      {isSubmitHappened &&
        role !== ConversationRole.USER &&
        canShowProgress && <SpinnerSimple className={styles.spinner} />}
    </div>
  );
};
